import React from 'react';
import Carousel from 'react-elastic-carousel';
import { numberSales } from '../../../assets/icons';
import PriceQty from '../price-qty-card';

const PriceQtyCarousel = ({ totalAffSales, numSales }) => {
  return (
    <div className="lg:hidden">
      <Carousel showArrows={false}>
        <div className="w-full">
          <PriceQty price={totalAffSales} />
        </div>
        <div className="w-full ml-3">
          <PriceQty
            icon={numberSales}
            title="Number of Sales"
            price={numSales}
          />
        </div>
      </Carousel>
    </div>
  );
};

export const PriceQtyCarouselQuo = ({ data }) => {
  return (
    <div className="lg:hidden">
      <Carousel showArrows={false}>
        {data &&
          data.map((item, index) => (
            <div
              className={`w-full ${index !== 0 ? 'ml-1' : null}`}
              key={index}
            >
              <PriceQty
                icon={item.icon}
                title={item.title}
                price={item.price}
              />
            </div>
          ))}
      </Carousel>
    </div>
  );
};
export default PriceQtyCarousel;
